import { styled } from "@mui/material/styles";
import hotelData from "./HotelData";
import { useNavigate } from "react-router-dom";
import pages from "../../../constants/pages";

const ListContainer = styled("ul")(() => ({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
  gap: "20px",
  padding: 0,
  listStyle: "none",
}));

const ListItem = styled("li")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  border: "1px solid #ddd",
  padding: "10px",
  backgroundColor: "#fff",
  transition: "transform 0.3s ease",

  "&:hover": {
    transform: "scale(1.05)",
  },

  "& a": {
    textDecoration: "none",
    color: "inherit",
  },

  "& img": {
    maxWidth: "100%",
    height: "auto",
  },

  "& h5": {
    fontSize: "18px",
    margin: "10px 0",
  },

  "& .info": {
    textAlign: "center",
  },

  "& .icons": {
    marginTop: "10px",
  },
}));

const HotelListView = () => {
  const navigate = useNavigate();
  return (
    <ListContainer>
      {hotelData.map((item, index) => (
        <ListItem key={index}>
          <a onClick={() => navigate(pages.Hotel.route + "?id=" + index)}>
            <figure className="shops-picture">
              <div>
                <h5>{item.name}</h5>
              </div>
            </figure>
            <figure className="shops-picture">
              <picture>
                <img
                  src={
                    "https://www.stuttgart-airport.com/media/185592/5_vor_flug_5060_lowres.jpg?anchor=center&mode=crop&width=600&height=400&rnd=131469262140000000"
                  }
                  alt={item.name}
                />
              </picture>
            </figure>
            <figure className="shops-picture">
              <div>
                <p className="open">
                  <b>
                    &#9679; {item.hours}
                    <br />
                  </b>
                </p>
                <div className="icons">
                  <i className="icon-close" role="img" aria-label="closed"></i>
                </div>
                <div className="info">
                  <div className="place">{item.description}</div>
                </div>
              </div>
            </figure>
          </a>
        </ListItem>
      ))}
    </ListContainer>
  );
};

export default HotelListView;
